import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { OFAC_FILE_BASE_PATH } from '../../../../../../../../../features/watchlist/ofac/file/ofac-file-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ofac-file-list',
        label: 'OFAC',
        to: OFAC_FILE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
